import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const DISMISSED_KEY = "vvs_cookie_notice_dismissed";
/**
 * Événement DOM natif (pas de dépendance/contexte React) — permet à
 * `WhatsAppFloatButton.tsx`, un composant totalement indépendant, de savoir
 * quand ce bandeau est fermé pour reprendre sa position habituelle. Porté à
 * l'identique depuis apps/web/components/layout/CookieNotice.tsx (seul
 * changement : `next/link` → `react-router-dom` `Link`).
 */
export const COOKIE_NOTICE_DISMISSED_EVENT = "vvs:cookie-notice-dismissed";

/**
 * Bandeau d'information cookies — PAS un bandeau de consentement
 * accepter/refuser : le site ne dépose que des cookies strictement
 * nécessaires (cf. `/politique-cookies`), aucun cookie de mesure d'audience
 * ni de publicité n'est soumis à consentement. Mémorisation en
 * `localStorage` : préférence purement locale au visiteur, dégradation
 * silencieuse (bandeau toujours affiché) si le stockage est inaccessible.
 */
export function CookieNotice() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(DISMISSED_KEY) !== "1") {
        setIsVisible(true);
      }
    } catch {
      setIsVisible(true);
    }
  }, []);

  function dismiss() {
    setIsVisible(false);
    try {
      window.localStorage.setItem(DISMISSED_KEY, "1");
    } catch {
      // Stockage indisponible : le bandeau réapparaîtra à la prochaine visite, sans gravité.
    }
    window.dispatchEvent(new Event(COOKIE_NOTICE_DISMISSED_EVENT));
  }

  if (!isVisible) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 bottom-16 z-50 border-t border-line bg-navy px-4 py-3 text-cream lg:bottom-0"
    >
      <div className="container-vvs flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
        <p className="font-body text-xs text-cream2 sm:text-sm">
          Ce site utilise uniquement des cookies nécessaires à son fonctionnement (panier, connexion) — aucun
          cookie de mesure d&apos;audience ni de publicité.{" "}
          <Link to="/politique-cookies" className="underline hover:text-gold">
            En savoir plus
          </Link>
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded-sm border border-gold bg-gold px-4 py-1.5 font-body text-xs font-semibold uppercase tracking-wide text-navy transition-colors hover:bg-gold2"
        >
          Compris
        </button>
      </div>
    </div>
  );
}
